import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import ModalContent from '@components/Modals/components/ModalContent';
import TextInput from '@components/Fields/TextInput';
import useTrackEvent from '@hooks/useTrackEvent';
import { useAddGameContext } from '../context/AddGameProvider';
import SaveGameDetails from '../SaveGameDetails';
const ContentCODConnect = ({ className, stepName, onSubmit }) => {
    var _a;
    const { connectGameService } = useAddGameContext();
    const [username, setUsername] = useState('');
    const trackEvent = useTrackEvent();
    const usernameText = (connectGameService === null || connectGameService === void 0 ? void 0 : connectGameService.gameServiceKey) === 'xboxlive' ? 'Gamertag' : 'Username';
    const handleChange = (e) => {
        setUsername(e.target.value);
    };
    const handleSubmit = () => {
        trackEvent({
            type: 'game_linking',
            data: {
                eventName: 'game linking',
                label: 'Connect',
                moduleName: 'Button',
                position: 0,
            },
        });
        if (onSubmit) {
            onSubmit(username);
        }
    };
    // Clears the username when game service changes.
    useEffect(() => {
        setUsername('');
    }, [connectGameService === null || connectGameService === void 0 ? void 0 : connectGameService.gameServiceKey]);
    /**
     * Adding undefined values in the DOM appear to cause localize to crash for all languages except english when the value changes
     * Seems like empty strings also cause the same issue as above, updated to a string with a space
     */
    const gameServiceName = (_a = connectGameService === null || connectGameService === void 0 ? void 0 : connectGameService.name) !== null && _a !== void 0 ? _a : ' ';
    return (_jsxs(ModalContent, { stepName: stepName, className: className, verticalAlign: "top", children: [_jsxs("section", { children: [_jsxs("h3", { children: ["How to connect a ", gameServiceName, " account"] }), _jsxs("ol", { children: [_jsxs("li", { children: ["Enter your ", gameServiceName, " ", usernameText, " in the field below"] }), _jsx("li", { children: "If you own the game and have played you should be able to connect" })] }), _jsx(TextInput, { id: "game-service-user-name", "data-ignore": true, placeholder: usernameText, value: username, onChange: handleChange, "aria-label": `${(connectGameService === null || connectGameService === void 0 ? void 0 : connectGameService.name) || ''} ${usernameText}` })] }), _jsx(SaveGameDetails, { lookupValue: username, onClick: handleSubmit })] }));
};
export default ContentCODConnect;
